import React from 'react';
import '../../styles/GeuModal.css';

export default function GeuModal({ isOpen, onClose, college }) {
  if (!isOpen) return null;

  // Define multi-brochure colleges
  const multibrochureColleges = {
    'graphic-era-dehradun': [
      { name: 'Graphic Era University', url: 'https://geu.ac.in/fee', label: 'GEU Fees' },
      { name: 'Graphic Era Hill University', url: 'https://gehu.ac.in/fee', label: 'GEHU Fees' }
    ]
  };

  const brochures = multibrochureColleges[college?.slug] || [];

  // If not Graphic Era or no brochures defined, don't show modal
  if (brochures.length === 0) return null;

  return (
    <div className="geu-modal-overlay" onClick={onClose}>
      <div className="geu-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="geu-modal-close" onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div className="geu-modal-header">
          <h2>Select Fee Structure</h2>
          <p>Choose the campus you're interested in</p>
        </div>

        <div className="geu-options">
          {brochures.map((brochure, idx) => (
            <button
              key={idx}
              className="geu-option-btn"
              onClick={() => {
                window.open(brochure.url, '_blank', 'noopener,noreferrer');
                onClose();
              }}
            >
              <div className="geu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="12" y1="18" x2="12" y2="12"></line>
                  <line x1="9" y1="15" x2="15" y2="15"></line>
                </svg>
              </div>
              <div className="geu-text">
                <h3>{brochure.label}</h3>
                <p>{brochure.name}</p>
              </div>
              <div className="geu-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
